import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Ofwca} from '../../../shared/interface/ofwca';
import {takeUntil} from 'rxjs/operators';
import {Krk} from '../../../shared/interface/krk';
import {MatTableDataSource} from '@angular/material/table';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {KrkService} from '../../../shared/services/krk.service';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {DocumentAddDialogComponent} from '../../documents/document-add-dialog/document-add-dialog.component';
import {FILE_TYPE_KRK} from '../../../shared/services/dict.service';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {KrkAddDialogComponent} from '../krk-add-dialog/krk-add-dialog.component';
import {MatPaginator} from '@angular/material/paginator';
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {Registration} from "../../../shared/interface/registration";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-krk-list',
  templateUrl: './krk-list.component.html',
  styleUrls: ['./krk-list.component.scss']
})
export class KrkListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() ofwca: ReplaySubject<Ofwca>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ofwcaObject: Ofwca;
  dataSource: MatTableDataSource<Krk>;
  displayedColumns: string[] = ['name', 'activeFee', 'status', 'activeTo', 'daysLeft', 'payer', 'actions', ];
  userPermissions: ReplaySubject<UserPermissions>;
  updateInProgress = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private krkService: KrkService,
    private ofwcaService: OfwcaService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.dataSource = new MatTableDataSource<Krk>([]);
    this.updateInProgress = false;
  }

  ngOnInit(): void {
    this.ofwca
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwca: Ofwca) => {
        this.ofwcaObject = ofwca;
        this.loadKrks();
      });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  loadKrks(): void {
    this.ofwcaService.getOfwcaKrks(this.ofwcaObject.uuid)
      .subscribe((response: ListResponse<Krk>) => {
        this.dataSource.data = response.items;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  addDocument(krk: Krk): void {

    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        krkObject: krk,
        types: [FILE_TYPE_KRK],
      },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  deleteKrk(krk: Krk): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć KRK?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.krkService.deleteKrk(krk.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto KRK', '', {duration: 2000});
            this.loadKrks();
          });
      }
    });
  }

  addKrk(): void {
    const dialogRef = this.dialog.open(KrkAddDialogComponent, {
      width: '500px',
      data: {
        ofwcaObject: this.ofwcaObject
      },
      height: '290px',
      maxHeight: '90%',
      panelClass: 'full-height-dialog',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadKrks();
    });
  }

  agreedToDeregisterChanged($event: MatSlideToggleChange, krk: Krk): void {
    this.updateInProgress = true;

    this.krkService.updateKrkActiveFeeController(krk.uuid, {
      activeFee: $event.checked
    })
      .subscribe(() => {
        this.snack.open('Pomyślnie zakutalizowano krk', '', {duration: 2000});
        this.updateInProgress = false;
        krk.activeFee = $event.checked;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.updateInProgress = false;
      });
  }
}
